import React, { createContext, PropsWithChildren, useContext, useMemo } from 'react';

import { useToggle } from 'react-use';

type SidebarContextType = {
  isCollapsed: boolean;
  toggleCollapsed: () => void;
};

const SidebarContext = createContext<SidebarContextType | null>(null);

type SidebarProviderProps = PropsWithChildren<{
  initialCollapsed?: boolean;
}>;

export const SidebarProvider = ({
  children,
  initialCollapsed = false,
}: SidebarProviderProps) => {
  const [isCollapsed, toggleCollapsed] = useToggle(initialCollapsed);

  const contextValue = useMemo(
    () => ({ isCollapsed, toggleCollapsed }),
    [isCollapsed, toggleCollapsed],
  );

  return <SidebarContext value={contextValue}>{children}</SidebarContext>;
};

export const useSidebarContext = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebarContext must be used within a SidebarProvider');
  }
  return context;
};
